import React, { Component } from 'react'
import { connect } from "react-redux"
import { bindActionCreators } from "redux";
import Switch from 'react-switchery';
import moment from 'moment'
import axios from 'axios'
import querystring from 'querystring'
import { WithContext as ReactTags } from 'react-tag-input';
import "../../../template/custom/react-tags.css";

import *as config from '../../../config'
import * as adminCompanyActions from "../../../actions/adminCompanyActions";
import './style.css'
import EditableText from '../../Shared/EditableText'
import Spinner from "../../Shared/Spinner";
import AdminMenu from "../../Shared/SideBar/AdminMenu";

class Company extends Component {
    constructor(props) {
        super(props)

        this.state = {
            fetching: false
        }

        let { adminCompanyActions } = props;
        let { id } = this.props.match.params;

        if (id != 0) {
            adminCompanyActions.Get(id);
        }






    }
    componentWillUnmount() {
        let { adminCompanyActions } = this.props;
        adminCompanyActions.Reset();
    }

    handleFieldChange(field, value) {
        let { adminCompanyActions } = this.props;
        adminCompanyActions.Change(field, value)
    }
    handleCompanySettingsChangeStartTime(e) {

        let timeHourAndMinutes = this.handleTime(e.target.value);
        let { adminCompanyActions } = this.props;
        adminCompanyActions.ChangeSettings("startHour", timeHourAndMinutes.hour)
        adminCompanyActions.ChangeSettings("startMinute", timeHourAndMinutes.minutes)
    }

    handleCompanySettingsChangeReportStartTime(e) {

        let timeHourAndMinutes = this.handleTime(e.target.value);
        //let { adminCompanyActions } = this.props;
        let { adminCompany, adminCompanyActions } = this.props;
        let { reportSettings } = adminCompany.data.companySettings;
        if (reportSettings === null) {
            
            reportSettings=  {
                reportGroup: [],
                startReportHour:0,
                startReportMinute:0
    
            }  
        }
        reportSettings["startReportHour"] = timeHourAndMinutes.hour;
        reportSettings["startReportMinute"] = timeHourAndMinutes.minutes;
        adminCompanyActions.ChangeSettings("reportSettings", reportSettings);
    }


    handleTime(time) {

        let splitedValue = time.split(":");

        let hour = splitedValue[0];
        let minutes = splitedValue[1];

        if (!hour) {
            hour = 0
        }
        if (!minutes) {
            minutes = 0
        }

        return {
            hour: hour,
            minutes: minutes
        }

    }

    handleCompanySettingsChange(field, value) {
        let { adminCompanyActions } = this.props;
        adminCompanyActions.ChangeSettings(field, value)
    }
    handleSubmit(e) {
        let { adminCompany } = this.props;
        let { id } = this.props.match.params;

        if (!this.state.fetching) {
            this.setState({
                fetching: true
            })

            let axiosMethod = "put";
            let apiMethod = "/companies/update"

            if (id == 0) {
                axiosMethod = "post"
                apiMethod = "/companies/create"
            }

            axios[axiosMethod](
                config.apiUrl + apiMethod,
                adminCompany.data
            ).then((response) => {
                console.log("response", response);
                this.setState({
                    fetching: false
                })
                this.props.history.push("/admin/companies")
            }).catch((err) => {
                this.setState({
                    fetching: false
                })
            })

        }


    }
    handleFolderAdd(e) {
        e.preventDefault();

        let { adminCompany, adminCompanyActions } = this.props;

        let { redmineFolders } = adminCompany.data.companySettings;

        redmineFolders.push("");

        adminCompanyActions.ChangeSettings("redmineFolders", redmineFolders);
    }
    handleFolderDelete(index) {
        let { adminCompany, adminCompanyActions } = this.props;

        let { redmineFolders } = adminCompany.data.companySettings;

        redmineFolders.splice(index, 1);

        adminCompanyActions.ChangeSettings("redmineFolders", redmineFolders);
    }
    handleFolderEdit(e, index) {
        let value = e.target.value;

        let { adminCompany, adminCompanyActions } = this.props;

        let { redmineFolders } = adminCompany.data.companySettings;

        redmineFolders[index] = value;

        adminCompanyActions.ChangeSettings("redmineFolders", redmineFolders);
    }
    handleGroupAdd(e) {
        let { adminCompany, adminCompanyActions } = this.props;

        let { reportSettings } = adminCompany.data.companySettings;

        let reportGroup = [];

        if (reportSettings !== null) {
            reportGroup = reportSettings.reportGroup
        }

        reportGroup.push({
            groupName: "",
            emails: ""
        })

        adminCompanyActions.ChangeSettings("reportSettings", {
            ...reportSettings,
            reportGroup: reportGroup
        });
    }
    handleGroupDelete(index) {
        let { adminCompany, adminCompanyActions } = this.props;

        let { reportSettings } = adminCompany.data.companySettings;
        let { reportGroup } = reportSettings;

        reportGroup.splice(index, 1);

        adminCompanyActions.ChangeSettings("reportSettings", {
            ...reportSettings,
            reportGroup: reportGroup
        });
    }
    handleGroupFieldChange(field, value, index) {
        let { adminCompany, adminCompanyActions } = this.props;

        let { reportSettings } = adminCompany.data.companySettings;
        let { reportGroup } = reportSettings;

        reportGroup[index][field] = value;

        adminCompanyActions.ChangeSettings("reportSettings", {
            ...reportSettings,
            reportGroup: reportGroup
        });
    }
    handleAdditionTag(tag, index) {
        let { adminCompanyActions } = this.props;
        let emails = this.helperGetEmails(index);

        let tags = this.funcGetTags(emails);

        let isAllredyinTags = false;

        tags.forEach((item) => {
            if (item.text === tag) {
                isAllredyinTags = true;
            }
        })

        if (!isAllredyinTags) {
            tags.push({
                id: tags.length + 1,
                text: tag
            });

            //save To Cookies
            adminCompanyActions.AddEmailPreset(tag)
            emails = this.funcGetEmails(tags);

            this.handleGroupFieldChange("emails", emails, index);
        }

    }
    handleDeleteTag(i, index) {
        let emails = this.helperGetEmails(index);

        let tags = this.funcGetTags(emails);
        tags.splice(i, 1);
        emails = this.funcGetEmails(tags);

        this.handleGroupFieldChange("emails", emails, index);

    }
    handleParsingSettingsChange(field, value) {
        let { adminCompany, adminCompanyActions } = this.props;

        let { parsingSettings } = adminCompany.data.companySettings;


        parsingSettings[field] = value;

        adminCompanyActions.ChangeSettings("parsingSettings", parsingSettings);
    }

    funcGetTags(emails) {
        let tags = [];
        if (emails) {
            let emailsArr = emails.split(";");

            emailsArr.forEach((item, index) => {
                if (item.length > 0) {
                    tags.push({
                        id: index,
                        text: item
                    })
                }
            })
        }

        return tags;
    }
    funcGetEmails(tags) {
        let emails = "";
        for (let i = 0; i < tags.length; i++) {
            emails += tags[i].text;

            if (i < tags.length - 1) {
                emails += ";"
            }
        }
        return emails;
    }

    helperGetEmails(index) {
        let { adminCompany, adminCompanyActions } = this.props;

        let { reportSettings } = adminCompany.data.companySettings;
        let { reportGroup } = reportSettings;
        let emails = reportGroup[index].emails;

        return emails;
    }

    render() {
        let { adminCompany } = this.props;
        let { data } = adminCompany;

        if (data == null) {
            return null;
        }
        let { companySettings } = data;
        let { reportSettings } = companySettings;


        let startHour = companySettings.startHour != null ? companySettings.startHour.toString() : "0";
        let startMinute = companySettings.startMinute != null ? companySettings.startMinute.toString() : "0";


        if (reportSettings == null) {
            reportSettings = {
                startReportHour: "0",
                startReportMinute: "0"
            }

        }
        let startReportHour = reportSettings.startReportHour != null ? reportSettings.startReportHour.toString() : "0";
        let startReportMinute = reportSettings.startReportMinute != null ? reportSettings.startReportMinute.toString() : "0";


        if (startHour.length < 2) {
            startHour = "0" + startHour;
        }
        if (startMinute.length < 2) {
            startMinute = "0" + startMinute;
        }
        if (startReportHour.length < 2) {
            startReportHour = "0" + startReportHour;
        }
        if (startReportMinute.length < 2) {
            startReportMinute = "0" + startReportMinute;
        }



        return (
            <div className="content admin-company-page">
                {
                    data === null ?
                        null
                        :
                        <React.Fragment>
                            <h1 className="company-name">
                                <EditableText
                                    key={data.id}
                                    value={data.name}
                                    placeholder="Введите название (Latin)"
                                    require={true}
                                    onSave={(value) => {
                                        this.handleFieldChange("name", value)
                                    }}
                                />
                            </h1>

                            <div className="form">
                                <div className="form-body ">


                                    <div className="switch-wrapp">
                                        <Switch
                                            key={data.id}
                                            className="switchery-default"
                                            onChange={(value) => this.handleFieldChange("isActive", value)}

                                            options={
                                                {
                                                    color: '#4CAF50',
                                                    size: "small"
                                                }
                                            }
                                            checked={data.isActive}
                                        />
                                        <label>
                                            {
                                                data.isActive ?
                                                    "Активный"
                                                    :
                                                    "Неактивный"
                                            }
                                        </label>
                                    </div>

                                    <div className="company-settings row">

                                        {/* <div className="tab-pane" id="shablon"> */}

                                        <div className="nav-tabs-custom">
                                            <ul className="nav nav-tabs" >

                                                <li className=" active">
                                                    <a className="nav-link" id="home-tab" data-toggle="tab" href="#shablon_admin" aria-expanded="true">Администрирование</a>
                                                </li>
                                                <li className="">
                                                    <a className="nav-link" id="profile-tab" data-toggle="tab" href="#shablon_report">Отчеты</a>
                                                </li>
                                            </ul>

                                            <div className="tab-content">
                                                <div className="tab-pane fade active in" id="shablon_admin" role="tabpanel" aria-labelledby="home-tab">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Время старта</label>
                                                            <input
                                                                type="time"
                                                                value={`${startHour}:${startMinute}`}
                                                                className="form-control"
                                                                onChange={(e) => this.handleCompanySettingsChangeStartTime(e)}
                                                            />
                                                        </div>
                                                    </div>



                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Название</label>
                                                            <input
                                                                type="text"
                                                                value={companySettings.name}
                                                                className="form-control"
                                                                onChange={(e) => this.handleCompanySettingsChange("name", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Алиас</label>
                                                            <input
                                                                type="text"
                                                                value={companySettings.alias}
                                                                className="form-control"
                                                                onChange={(e) => this.handleCompanySettingsChange("alias", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Описание</label>
                                                            <input
                                                                type="text"
                                                                value={companySettings.description}
                                                                className="form-control"
                                                                onChange={(e) => this.handleCompanySettingsChange("description", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>


                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>
                                                                Микроразметка
                                                </label>
                                                            <Switch
                                                                className="switchery-default"
                                                                onChange={(value) => this.handleFieldChange("microMarckup", value)}
                                                                key={`${data.id}-microMarckup`}
                                                                options={
                                                                    {
                                                                        color: '#4CAF50',
                                                                        size: "small"
                                                                    }
                                                                }
                                                                checked={data.microMarckup}
                                                            />

                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Sitemap</label>
                                                            <input
                                                                type="text"
                                                                value={data.sitemap ? data.sitemap : ""}
                                                                className="form-control"
                                                                onChange={(e) => this.handleFieldChange("sitemap", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Url</label>
                                                            <input
                                                                type="text"
                                                                value={data.url}
                                                                className="form-control"
                                                                onChange={(e) => this.handleFieldChange("url", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Шард</label>
                                                            <input
                                                                type="text"
                                                                value={data.shard}
                                                                className="form-control"
                                                                onChange={(e) => this.handleFieldChange("shard", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>


                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>
                                                                Подробное логирование
                                                </label>
                                                            <Switch
                                                                className="switchery-default"
                                                                onChange={(value) => this.handleParsingSettingsChange("enableHttpRequestsLogging", value)}
                                                                key={`${data.id}-enableHttpRequestsLogging`}
                                                                options={
                                                                    {
                                                                        color: '#4CAF50',
                                                                        size: "small"
                                                                    }
                                                                }
                                                                checked={companySettings.parsingSettings.enableHttpRequestsLogging}
                                                            />

                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>
                                                                Подключение через прокси
                                                </label>
                                                            <Switch
                                                                className="switchery-default"
                                                                onChange={(value) => this.handleParsingSettingsChange("useProxy", value)}
                                                                key={`${data.id}-useProxy`}
                                                                options={
                                                                    {
                                                                        color: '#4CAF50',
                                                                        size: "small"
                                                                    }
                                                                }
                                                                checked={companySettings.parsingSettings.useProxy}
                                                            />

                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Количество потоков</label>
                                                            <input
                                                                type="text"
                                                                value={companySettings.parsingSettings.numberOfTread}
                                                                className="form-control"
                                                                onChange={(e) => this.handleParsingSettingsChange("numberOfTread", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Количество данных(порций) для записи в БД</label>
                                                            <input
                                                                type="text"
                                                                value={companySettings.parsingSettings.offersPortion}
                                                                className="form-control"
                                                                onChange={(e) => this.handleParsingSettingsChange("offersPortion", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Показывать на портале</label>
                                                            <Switch
                                                                key={data.id}
                                                                className="switchery-default"
                                                                onChange={(value) => this.handleFieldChange("isVisible", value)}

                                                                options={
                                                                    {
                                                                        color: '#4CAF50',
                                                                        size: "small"
                                                                    }
                                                                }
                                                                checked={data.isVisible}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-9">
                                                        <div className="form-group">
                                                            <label>Ссылка на демонстрационные данные</label>
                                                            <input
                                                                type="text"
                                                                value={data.demo ? data.demo : ""}
                                                                className="form-control"
                                                                onChange={(e) => this.handleFieldChange("demo", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group groups">
                                                            <label>Группы</label>
                                                            {
                                                                companySettings.reportSettings ?

                                                                    companySettings.reportSettings.reportGroup.map((item, index) => {



                                                                        let tags = this.funcGetTags(item.emails)

                                                                        return (

                                                                            <div className="panel panel-flat">
                                                                                <div className="panel-heading">
                                                                                    <div className="input-group">

                                                                                        <input
                                                                                            type="text"
                                                                                            value={item.groupName}
                                                                                            className="form-control"
                                                                                            placeholder="Название группы"
                                                                                            onChange={(e) => this.handleGroupFieldChange("groupName", e.target.value, index)}
                                                                                        />
                                                                                        <span className="input-group-btn">
                                                                                            <button title="Удалить группу" className="btn btn-warning" type="button" onClick={(e) => { this.handleGroupDelete(index) }}>
                                                                                                <i className="glyphicon glyphicon-minus"></i>
                                                                                            </button>
                                                                                        </span>
                                                                                    </div>

                                                                                </div>

                                                                                <div className="panel-body">
                                                                                    <ReactTags
                                                                                        placeholder="Введите email и нажмите <Enter>"
                                                                                        tags={tags}
                                                                                        classNames={{
                                                                                            tagInputField: "form-control"
                                                                                        }}
                                                                                        suggestions={adminCompany.emailsPreset}
                                                                                        handleDelete={(i) => this.handleDeleteTag(i, index)}
                                                                                        handleAddition={(tag) => this.handleAdditionTag(tag, index)}
                                                                                    // handleDrag={this.handleDrag}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                    : null
                                                            }
                                                            <div>
                                                                <button title="Добавить группу" className="btn btn-success" type="button"
                                                                    onClick={(e) => this.handleGroupAdd(e)}
                                                                >
                                                                    <i className="glyphicon glyphicon-plus"></i>
                                                                </button>

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="form-group redmine-folders">
                                                            <label>Папки в облаке</label>
                                                            {
                                                                companySettings.redmineFolders.map((item, index) => {
                                                                    return (

                                                                        <div className="input-group folder-item" key={index}>
                                                                            <input
                                                                                key={index}
                                                                                type="text"
                                                                                value={item}
                                                                                className="form-control"
                                                                                onChange={(e) => this.handleFolderEdit(e, index)}
                                                                            />
                                                                            <span className="input-group-btn">
                                                                                <button title="Удалить папку" className="btn btn-warning" type="button" onClick={(e) => { this.handleFolderDelete(index) }}>
                                                                                    <i className="glyphicon glyphicon-minus"></i>
                                                                                </button>
                                                                            </span>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                            <div>
                                                                <button title="Добавить папку" className="btn btn-success" type="button" onClick={(e) => this.handleFolderAdd(e)}>
                                                                    <i className="glyphicon glyphicon-plus"></i>
                                                                </button>

                                                            </div>
                                                        </div>
                                                    </div>



                                                </div>
                                                <div className="tab-pane fade" id="shablon_report" role="tabpanel" aria-labelledby="home-tab">

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Время старта</label>
                                                            <input
                                                                type="time"
                                                                value={`${startReportHour}:${startReportMinute}`}
                                                                className="form-control"
                                                                onChange={(e) => this.handleCompanySettingsChangeReportStartTime(e)}
                                                            />
                                                        </div>
                                                    </div>


                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label>Отчеты</label>
                                                            <div className="panel panel-flat">
                                                                <div className="panel-heading">

                                                                </div>


                                                                {/* item.companyId != ""? */}
                                                                <div className="panel-body">
                                                                    <div class="search-input  select"><input class="form-control" value="" placeholder="Выберите отчет инажмите <Enter>" />
                                                                    </div>



                                                                    {/* {
                                                                                    item.regions.map((regionId)=>{
                                                                                        let region = this.getRegion(regionId)
                                                                                        return(
                                                                                            <span key={regionId} className="ReactTags__tag"  draggable="true">
                                                                                                        {region}
                                                                                                <a className="ReactTags__remove" onClick={()=>this.handleDeleteBindingRegion(regionId,index)}>×</a>
                                                                                                        </span>
                                                                                        )
                                                                                    })
                                                                                }
                                                                                <SearchInput
                                                                                    className=""
                                                                                    //apiUrl="https://api.xmldatafeed.com/companies/all?name="
                                                                                    items ={config.regions}
                                                                                    onObjectChange={(obj) => {
                                                                                        console.log("obj",obj)
                                                                                        this.handleAddBindingRegion(obj.id,index)
                                                                                        }
                                                                                    }
                                                                                    // outObject={this.state.data.City}
                                                                                    //value={consolidatedReportSettings.companyName}
                                                                                    placeholder="Выберите регион и нажмите <Enter>"
                                                                                    mapping={{
                                                                                        id:"key",
                                                                                        value:"{value}"
                                                                                    }}
                                                                                    clearAfterChoice={true}
                                                                                /> */}

                                                                </div>

                                                            </div>
                                                        </div>





                                                    </div>


                                                </div>
                                            </div>
                                        </div>

                                        {/* </div> */}
                                    </div>

                                </div>

                                <div className=" row form-footer text-left">
                                    <button type="submit" className="btn btn-primary" onClick={(e) => this.handleSubmit(e)}>
                                        {
                                            this.state.fetching ?
                                                <Spinner />
                                                : <span>Сохранить</span>
                                        }
                                    </button>
                                </div>
                            </div>
                        </React.Fragment>
                }

            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        adminCompany: state.adminCompany
    }
}

function mapDispatchToProps(dispath) {
    return {
        adminCompanyActions: bindActionCreators(adminCompanyActions, dispath),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Company);


// WEBPACK FOOTER //
// ./src/components/Admin/Company/index.jsx